export default class Service {
  id: number = 0;
  name: string = "";
  code: string = "";
  availableUsers: number = 0;
  arise: string = "";
  service: string = "";
  viewAllServiceTasks: boolean = false;
  storage_limit: number = 0;
  storage_used: number = 0;
  storage_old: number = 0;
  disabled: boolean = false;
  settlementMonth!: number;
  scheduleNotification!: boolean;

  public constructor(params: Params = {}) {
    if (params.id) this.id = params.id;
    if (params.name) this.name = params.name;
    if (params.code) this.code = params.code;
    if (params.availableUsers) this.availableUsers = params.availableUsers;
    if (params.arise) this.arise = params.arise;
    if (params.service) this.service = params.service;
    if (params.viewAllServiceTasks)
      this.viewAllServiceTasks = params.viewAllServiceTasks;
    if (params.storage_limit) this.storage_limit = params.storage_limit;
    if (params.storage_used) this.storage_used = params.storage_used;
    if (params.storage_old) this.storage_old = params.storage_old;
    if (params.disabled) this.disabled = params.disabled;
    if (params.settlementMonth) this.settlementMonth = params.settlementMonth;
    if (params.scheduleNotification)
      this.scheduleNotification = params.scheduleNotification;
  }
}

interface Params {
  id?: number;
  name?: string;
  code?: string;
  availableUsers?: number;
  arise?: string;
  service?: string;
  viewAllServiceTasks?: boolean;
  storage_limit?: number;
  storage_used?: number;
  storage_old?: number;
  disabled?: boolean;
  settlementMonth?: number;
  scheduleNotification?: boolean;
}
